module.exports = __webpack_public_path__ + "img/gitlab_active.e52461da.png";